module.exports = __webpack_public_path__ + "img/ios_safari.6c18a721.gif";